/* @flow */

// Libs
import React from 'react'
import { Layout } from 'hfty-layout'
import Spinner from 'react-spinkit'

// Redux
import { connect } from 'react-redux'

// Action Creators
// import { toggleAppMenu } from 'data/navigation'

// Selectors
import { isAuthenticated$, token$ } from 'fc-auth'
import { isBooting$ } from 'hfty'
import { eulaSigned$ } from 'hfty-auth'

// Components
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'
import { Login } from 'hfty-components-auth'
import withViewport from 'hocs/withViewport'

// Routes
import Assets from './Assets'
import SoilJobs from './SoilJobs'
import HeftyMap from './Map'
import GettingStarted from './GettingStarted'
import Accounts from './Accounts'
import OrderSupplies from './OrderSupplies'
import OrderTests from './OrderTests'
import { CheckoutOrderTests, CheckoutOrderSupplies } from 'routes/Checkout'
import Users from './Users'
import ContactUs from './ContactUs'
import Comments from './Comments'
import ForgotPassword from './ForgotPassword'
import ResetPassword from './ResetPassword'
// import Migration from './Migration'
import { RecommendedRates } from 'hfty-comments-dom'
import Recommendations from './Recommendations'
import AddRecommendation from './AddRecommendation'
import EditRecommendation from './EditRecommendation'
import RecommendationStatusBar from './RecommendationStatus'
import Reports from './Reports'
import PrivacyPolicy from './PrivacyPolicy'

// Styles
// const componentStyle = {}
const styles = {
  spinnerDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

// Types
type Props = {
  isAuthenticated: boolean,
  // token: ?string,
  history: any,
  viewport: { width: number, height: number }, // eslint-disable-line
  isBooting: boolean,
  eulaSigned: boolean,
  isFetchingEulaSigned: boolean,
}

type ConnectedProps = {
  eulaSigned: ?boolean,
  isFetchingEulaSigned: ?boolean,
  isAuthenticated: boolean,
  token: ?string,
  isBooting: boolean,
}

// Exports
export const Router = (props: Props): React.ReactElement => {
  const eulaSigned = props.eulaSigned
  const isFetchingEulaSigned = props.isFetchingEulaSigned
  const isAuthenticated = props.isAuthenticated
  const isBooting = props.isBooting

  return (
    <ConnectedRouter history={props.history}>
      <Layout
        viewport={props.viewport}
        isAuthenticated={isAuthenticated}
        eulaSigned={eulaSigned}
        isFetchingEulaSigned={isFetchingEulaSigned}
      >
        <Route
          path={'/'}
          render={(): React.Element<any> => {
            if (isBooting) {
              return (
                <div style={styles.spinnerDiv}>
                  <Spinner name="three-bounce" />
                </div>
              )
            } else if (isAuthenticated) {
              return (
                <Switch>
                  <Redirect exact from="/" to="/jobs" />
                  <Route path="/map" component={HeftyMap} />
                  <Route path="/assets/:category?" component={Assets} />
                  <Route path="/getting-started" component={GettingStarted} />
                  <Route path="/my-account" component={Users} />
                  <Route path="/order-tests/checkout/:orderId" component={CheckoutOrderTests} />
                  <Route path="/order-supplies/checkout/:orderId" component={CheckoutOrderSupplies} />
                  <Route path="/order-supplies" component={OrderSupplies} />
                  <Route path="/order-tests" component={OrderTests} />
                  <Route
                    path="/contact-us"
                    render={(): React.Element<any> => <ContactUs viewport={props.viewport} />}
                  />
                  <Route
                    path="/recommendations/:jobId/:fieldId/edit/:recommendationId"
                    component={EditRecommendation}
                  />
                  <Route path="/recommendations/:jobId/:fieldId/add" component={AddRecommendation} />
                  <Route path="/recommendations/:jobId" component={Recommendations} />
                  <Route path="/recommendation-status/:jobId/:recommendationId" component={RecommendationStatusBar} />
                  <Route path="/comments/:jobId/recommendedRates/:commentId" component={RecommendedRates} />
                  <Route path="/comments/:jobId" component={Comments} />
                  <Route path="/reports/:resultsType/:id" component={Reports} />
                  <Route path="/privacy-policy" component={PrivacyPolicy} />
                  <Route path="/" component={SoilJobs} />
                </Switch>
              )
            } else {
              return (
                <Switch>
                  <Route path="/registration" component={Accounts} />
                  <Route path="/forgotpassword" component={ForgotPassword} />
                  <Route path="/password/reset/:token" component={ResetPassword} />
                  <Route path="/privacy-policy" component={PrivacyPolicy} />
                  {/* <Route path='/migrate' component={Migration} /> */}
                  <Route path="/" render={(): React.Element<any> => <Login viewport={props.viewport} />} />
                </Switch>
              )
            }
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

function mapStateToProps(state: Object): ConnectedProps {
  return {
    ...eulaSigned$(state),
    isAuthenticated: isAuthenticated$(state),
    token: token$(state),
    isBooting: isBooting$(state),
  }
}

export default connect(mapStateToProps, null, null, { pure: false })(withViewport(Router))
